import NotificationSettingsScreen from 'features/myVaro/screens/NotificationSettings/NotificationSettingsScreen';
import React from 'react';

export default function Page() {
  return <NotificationSettingsScreen />;
}
